import React from 'react'
import { format, setMonth } from 'date-fns'
import { ptBR } from 'date-fns/locale'

const getMonthName = monthIndex => {
	return format(setMonth(new Date(), monthIndex), 'LLLL', { locale: ptBR })
}

const groupByMonth = holidays => {
	return holidays.reduce((acc, holiday) => {
		const [month, day] = holiday.date.split('/')
		const monthIndex = parseInt(month, 10) - 1
		if (!acc[monthIndex]) acc[monthIndex] = []
		acc[monthIndex].push({ day, title: holiday.title })
		return acc
	}, [])
}

export function HolidayList({ holidays }) {
	const holidaysByMonth = groupByMonth(holidays)

	return (
		<div className='tw-font-sans tw-text-gray-800 tw-p-6 desktop:tw-fixed tw-bg-purple-50 tw-rounded-lg tw-h-full desktop:tw-h-[calc(100vh_-_245px)] tw-overflow-auto desktop:tw-w-[380px] '>
			{holidaysByMonth.map(
				(holidays, index) =>
					holidays && (
						<div key={index} className='tw-mb-6'>
							<h3 className='tw-text-gray-500 tw-uppercase tw-text-sm tw-font-md tw-mb-4'>{getMonthName(index).toUpperCase()}</h3>
							{holidays.map((holiday, i) => (
								<div key={i} className='tw-flex tw-items-start tw-gap-4 tw-mb-2'>
									<span className='tw-text-purple-500 tw-font-bold'>
										{holiday.day.padStart(2, '0')}/{(index + 1).toString().padStart(2, '0')}
									</span>
									<span className='tw-text-black tw-font-medium'>{holiday.title}</span>
								</div>
							))}
						</div>
					)
			)}
		</div>
	)
}
